export class Tools {

    static sleep(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

}